import React from 'react';
import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface UserVersionsProps {
  total: number;
  currentIndex: number;
  onPrevious: () => void;
  onNext: () => void;
}

export const UserVersions: React.FC<UserVersionsProps> = ({
  total,
  currentIndex,
  onPrevious,
  onNext,
}) => {
  if (total <= 1) return null;

  const hasPrevious = currentIndex > 0;
  const hasNext = currentIndex < total - 1;

  return (
    <div className="flex items-center gap-1">
      <Button
        variant="ghost"
        size="icon"
        className="h-6 w-6"
        onClick={onPrevious}
        disabled={!hasPrevious}
      >
        <ChevronLeft className="h-3 w-3" />
      </Button>

      <span className="text-xs text-muted-foreground px-1">
        {currentIndex + 1}/{total}
      </span>

      <Button
        variant="ghost"
        size="icon"
        className="h-6 w-6"
        onClick={onNext}
        disabled={!hasNext}
      >
        <ChevronRight className="h-3 w-3" />
      </Button>
    </div>
  );
};
